import { render, staticRenderFns } from "./GiftCard.vue?vue&type=template&id=da98fb44"
import script from "./GiftCard.vue?vue&type=script&lang=js"
export * from "./GiftCard.vue?vue&type=script&lang=js"
import style0 from "./GiftCard.vue?vue&type=style&index=0&id=da98fb44&prod&lang=scss&data-gift-card=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports